var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledDashboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1072_52536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0H4C1.79086 0 0 1.79086 0 4V7C0 9.20914 1.79086 11 4 11H7C9.20914 11 11 9.20914 11 7V4C11 1.79086 9.20914 0 7 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0H17C14.7909 0 13 1.79086 13 4V7C13 9.20915 14.7909 11 17 11H20C22.2091 11 24 9.20915 24 7V4C24 1.79086 22.2091 0 20 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 13H4C1.79086 13 0 14.7909 0 17V20C0 22.2092 1.79086 24 4 24H7C9.20914 24 11 22.2092 11 20V17C11 14.7909 9.20914 13 7 13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 13H17C14.7909 13 13 14.7909 13 17V20C13 22.2092 14.7909 24 17 24H20C22.2091 24 24 22.2092 24 20V17C24 14.7909 22.2091 13 20 13Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1072_52536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledDashboardIcon);
export default __webpack_public_path__ + "static/media/filled-dashboard-icon.9b51411d52ae8c71145905edf81f1e5f.svg";
export { ForwardRef as ReactComponent };